<template>
  <div class="flexbox-c header" >
    <Menu />
    <div class="websittitle">MAKE YOUR LIFE MORE INTERESTING</div>
    <div class="flexbox-c loginbox">
      <div style="width: 1000px;">
        <img src="data:image/png;base64,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" alt="" class="logo">
        <a href="#/home" class="router-link-active router-link-exact-active btn" aria-current="page">{{ $t('user.main') }}</a>
        <a href="#/member/pc" class="btn">{{ $t('user.member') }}</a>
        <a href="#/chat/pc" class="btn">{{ $t('user.chat') }}
          <div class="el-badge item" >
            <span  style="display: inline-block; width: 1px; height: 20px;"></span>
            <sup class="el-badge__content el-badge__content--danger is-fixed" style="display: none;">0</sup>
          </div>
        </a>
        <a href="#/pay/pc" class="btn" >{{ $t('user.recharge') }}</a>
        <a href="#/upgrade/pc" class="btn" >{{ $t('user.upgrade') }}</a>
        <a href="#/store/pc" class="btn" >{{ $t('user.store') }}</a>
      </div>
    </div>
  </div>
</template>

<script>
import Menu from '@/components/Menu.vue'
export default {
  components: { Menu },
  name: 'Head',
  props: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import '../assets/css/iconfont.css';
@import "../assets/css/common.css";
.header {
  width: 100%;
  height: 500px;
  background-image: url(../assets/img/bg1.jpg);
  background-size: cover;
  background-position: 50%;
  align-content: space-between;
}
.header .websittitle{
  color: #fff;
  font-size: 50px;
  margin-top: 150px;
  padding-right: 100px;
  font-family: Times New Roman,Times,serif;
}
.header .loginbox {
  width: 100%;
  min-width: 1000px;
  height: 75px;
  background: hsla(0,0%,100%,.3);
  align-self: flex-end;
  padding-top: 20px;
  text-align: left;
}
.header .loginbox .logo{
  width: 40px;
  height: 40px;
  margin-right: 60px;
  margin-left: 15px;
}

.header .loginbox .btn:hover, .header .loginbox .router-link-active {
  text-decoration: underline;
}
.header .loginbox .btn{
  padding-top: 10px;
  padding-right: 20px;
  font-size: 21px;
  color: #513b5a;
}
</style>
